import { ErrorBoundary } from "components";
import XaneLoader from "components/XaneLoader";
import { lazy, Suspense } from "react";

const Home = lazy(() => import("containers/Home"));
const About = lazy(() => import("containers/About"));
const HowItWorks = lazy(() => import("containers/HowItWorks"));
const Blogs = lazy(() => import("containers/Blogs"));
const Contact = lazy(() => import("containers/Contact"));
const BlogsDetails = lazy(() => import("containers/BlogsDetails"));
const TermsAndConditions = lazy(() => import("containers/StaticPage/TermsAndConditions"));
const Cookies = lazy(() => import("containers/StaticPage/Cookies"));
const Disclaimer = lazy(() => import("containers/StaticPage/Disclaimer"));
const PrivacyPolicy = lazy(() => import("containers/StaticPage/PrivacyPolicy"));
const UsagePolicy = lazy(() => import("containers/StaticPage/UsagePolicy"));

function LazyHome(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <Home {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
function LazyAbout(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <About {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
function LazyBlogs(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <Blogs {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
function LazyBlogsDetails(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <BlogsDetails {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}

function LazyContact(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <Contact {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
function LazyHowItWorks(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <HowItWorks {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}

function LazyTermsAndConditions(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <TermsAndConditions {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
function LazyCookies(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <Cookies {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
function LazyDisclaimer(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <Disclaimer {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
function LazyPrivacyPolicy(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <PrivacyPolicy {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
function LazyUsagePolicy(props) {
  return (
    <Suspense fallback={<XaneLoader />}>
      <ErrorBoundary>
        <UsagePolicy {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
const routes = [
  {
    name: "Home",
    key: "home",
    route: "/",
    layout: "",
    component: <LazyHome />,
  },
  {
    name: "About",
    key: "about",
    route: "/about",
    layout: "",
    component: <LazyAbout />,
  },
  {
    name: "howitworks",
    key: "works",
    route: "/works",
    layout: "",
    component: <LazyHowItWorks />,
  },
  {
    name: "Blogs",
    key: "blogs",
    route: "/blogs",
    layout: "",
    component: <LazyBlogs />,
  },
  {
    name: "BlogsDetails",
    key: "blogsdetails",
    route: "/blog/:id",
    layout: "",
    component: <LazyBlogsDetails />,
  },

  {
    name: "Contact",
    key: "contact",
    route: "/contact",
    layout: "",
    component: <LazyContact />,
  },
  {
    name: "Terms & Conditions ",
    key: "terms & conditions ",
    route: "/terms",
    layout: "",
    component: <LazyTermsAndConditions />,
  },
  {
    name: "Cookies ",
    key: "cookies",
    route: "/cookies",
    layout: "",
    component: <LazyCookies />,
  },
  {
    name: "Disclaimer ",
    key: "disclaimer",
    route: "/disclaimer",
    layout: "",
    component: <LazyDisclaimer />,
  },
  {
    name: "Privacy",
    key: "privacy",
    route: "/privacy",
    layout: "",
    component: <LazyPrivacyPolicy />,
  },
  {
    name: "Usage",
    key: "usage",
    route: "/usage",
    layout: "",
    component: <LazyUsagePolicy />,
  },
  {
    name: "Unknown",
    key: "home",
    route: "*",
    layout: "",
    component: <LazyHome />,
  },
];

export default routes;
